<template>
<v-container pa-0 grid-list-md text-xs-center dark>
  <v-layout  row wrap>

     <v-flex xs12 v-if="filterRole(['administrador'])">
      <v-card>
        <v-card-title pa-0 primary-title class="grey lighten-4">

          <v-tooltip top>
                  <v-btn
                        slot="activator"
                        dark
                        @click.stop="dialog = true"
                        icon class="mx-0">
                     <v-icon color="red">help</v-icon>
                 </v-btn>
             <span>Atención técnica</span>
          </v-tooltip>

          <h3 class="headline mb-0">Métricas</h3>

        </v-card-title>

              <!-- Inicio de las tarjetas -->
        <v-container>
         <v-layout row wrap>
            <v-flex
              sm3  xs12  md3  lg3>
              <statscard     color="green"     icon="mdi-account"     title="Agremiados"     :value="`${agremiados}`"     small-value="Lics."     sub-icon="mdi-calendar"     sub-text="Registro histórico" />
            </v-flex>

            <v-flex  sm3  xs12  md3  lg3>
              <statscard
                color="red"     icon="mdi-information-outline"     :title="`Ingresos ${yearMonthString}: ${ingresoMesActual}`"     :value="`Mes pasado: ${ingresoMesPasado}`"     sub-icon="mdi-tag"     :sub-text="`Hasta hoy ${ingresoMesActual} Incorporaciones durante ${yearMonthString}`" />
            </v-flex>

            <v-flex  sm3  xs12  md3  lg3>
              <statscard     color="orange"     icon="mdi-cash"     title="Agremiados Insolventes"     :value="`${insolventes}`"     small-value="Lics."   sub-icon="mdi-alert"     sub-icon-color="error"     sub-text="Gestionar cobranza"     sub-text-color="text-primary"/>
            </v-flex>

            <v-flex  sm6  xs12  md6  lg3>
              <statscard
                color="info"     icon="mdi-account-star"     title="Agremiados activos en el portal web"     :value="`${activos_portal}`"     small-value="Lics."     sub-icon="mdi-update"     sub-text="Agremiados autenticados en el portal"/>
            </v-flex>

            <v-flex  sm6  xs12  md6  lg3>
              <statscard     color="grey"     icon="mdi-bank"     title="CxP Crédito Acumulado"     :value="`${credito}`"     small-value="BsS."     sub-icon="mdi-help"     sub-icon-color="warning"     sub-text="Saldo acumulado a favor de los agremiados"     sub-text-color="text-primary"   />
            </v-flex>

         </v-layout>
        </v-container>
        <v-container>






        <!-- Data Table de la Facturacion -->
        </v-container>
          <v-layout row wrap>
              <v-flex>
                <card
                  color="green"
                  :title="`Facturación por Registro de Actuación Profesional y/o Compra de Hojas de Seguridad durante el año ${yearString}`"
                  text="Pagos aprobados"
                >
                      <v-data-table
                        :headers="headersInvoices"
                        :items="invoices"
                        class="elevation-1"
                        rows-per-page-text="Filas por Pág"
                        :rows-per-page-items='[6,12,{"text":"Todos","value":-1}]'
                      >
                        <template slot="headerCell" slot-scope="props">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <span v-on="on">
                                {{ props.header.text }}
                              </span>
                            </template>
                            <span>
                              {{ props.header.text }}
                            </span>
                          </v-tooltip>
                        </template>
                        <template v-slot:items="props">
                          <td>{{ props.item.meses }}</td>
                          <td class="text-xs-right">{{ props.item.cantidad_facturas }}</td>
                          <td class="text-xs-right">{{ new Intl.NumberFormat("de-DE").format(props.item.monto_facturado) }}</td>
                          <td class="text-xs-right">{{ new Intl.NumberFormat("de-DE").format(props.item.cant_hojas_seg_pagadas) }}</td>
                          <td class="text-xs-right">{{ new Intl.NumberFormat("de-DE").format(props.item.monto_hojas_seg_pagadas) }}</td>
                          <td class="text-xs-right">{{ new Intl.NumberFormat("de-DE").format(props.item.cant_rap_pagados) }}</td>
                          <td class="text-xs-right">{{ new Intl.NumberFormat("de-DE").format(props.item.monto_rap_pagados) }}</td>
                          <td class="text-xs-right">{{ new Intl.NumberFormat("de-DE").format(props.item.monto_total_conciliado) }}</td>
                        </template>
                      </v-data-table>
                </card>
              </v-flex>


              <v-flex>
                <card
                  color="red"
                  :title="`Facturación por Cuotas de Sostenimiento durante el año ${yearString}`"
                  text="Pagos aprobados"
                >
                      <v-data-table
                        :headers="headersSostenimiento"
                        :items="sostenimiento"
                        class="elevation-1"
                        rows-per-page-text="Filas por Pág"
                        :rows-per-page-items='[6,12,{"text":"Todos","value":-1}]'
                      >
                        <template slot="headerCell" slot-scope="props">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <span v-on="on">
                                {{ props.header.text }}
                              </span>
                            </template>
                            <span>
                              {{ props.header.text }}
                            </span>
                          </v-tooltip>
                        </template>
                        <template v-slot:items="props">
                          <td>{{ props.item.meses }}</td>
                          <td class="text-xs-right">{{ props.item.cantidad_facturas }}</td>
                          <td class="text-xs-right">{{ new Intl.NumberFormat("de-DE").format(props.item.monto_facturado) }}</td>
                          <td class="text-xs-right">{{ new Intl.NumberFormat("de-DE").format(props.item.cant_solvencias_pagadas) }}</td>
                          <td class="text-xs-right">{{ new Intl.NumberFormat("de-DE").format(props.item.monto_solvencias_pagadas) }}</td>
                          <td class="text-xs-right">{{ new Intl.NumberFormat("de-DE").format(props.item.cant_solvencias_pendientes) }}</td>
                          <td class="text-xs-right">{{ new Intl.NumberFormat("de-DE").format(props.item.monto_solvencias_pendientes) }}</td>
                          <td class="text-xs-right">{{ new Intl.NumberFormat("de-DE").format(props.item.monto_total_conciliado) }}</td>
                        </template>
                      </v-data-table>
                </card>
              </v-flex>
            </v-layout>

      </v-card>

    </v-flex>
  </v-layout>
<v-dialog
      v-model="dialog"
      max-width="600"
    >
      <v-card>
        <v-card-title class="headline">Servicios</v-card-title>

        <v-card-text>
          Indicadores de primer nivel relacionado con el <span style="color: #9C1A1A">{{ appName }}</span>.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="dialog = false"
          >
            Salir
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
</v-container>

</template>

<script>
import moment from 'moment';
moment.locale('es');
import axios from 'axios'
import { mapGetters } from 'vuex'
import statscard from '~/components/material/StatsCard.vue'
import card from '~/components/material/Card.vue'
import MonthlySatChart from '~/components/charts/MonthlySatChart.vue'


export default {
  name: "view-home",

  components: {
    statscard, MonthlySatChart, card
  },

  data () {
    return {
      appName: window.config.appName,
      yearMonthString: '',
      yearMonthLastString: '',
      data: [],
      agremiados: '0',
      credito: '0',
      insolventes: '0',
      activos_portal: '0',
      magazzineDownload: '0',
      nuevoIngreso: '0',
      ingresoMesActual: '0',
      ingresoMesPasado: '0',
      ruapsHoy: '0',
      misactuaciones: '0',
      pendientes: '0',
      porrevisar: '0',
      dialog: false,
      dialogo: false,
      loading: false,
      headersInvoices: [
          {
            text: 'MESES',
            align: 'left',
            sortable: true,
            value: 'meses'
          },
          { text: 'CANT. FACTURAS', value: 'cantidad_facturas' },
          { text: 'MONTO FACTURADO', value: 'monto_facturado' },
          { text: 'CANT. X HJS. SEG.', value: 'cant_hojas_seg_pagadas' },
          { text: 'MONTO X HJS. SEG', value: 'monto_hojas_seg_pagadas' },
          { text: 'CANT. X RAP.', value: 'cant_rap_pagados' },
          { text: 'MONTO X RAP', value: 'monto_rap_pagados' },
          { text: 'MONTO CONCILIADO', value: 'monto_total_conciliado' }

        ],
      headersSostenimiento: [
          {
            text: 'MESES',
            align: 'left',
            sortable: true,
            value: 'meses'
          },
          { text: 'CANT. FACTURAS', value: 'cantidad_facturas' },
          { text: 'MONTO FACTURADO', value: 'monto_facturado' },
          { text: 'CANT. SOLV. PAGADAS', value: 'cant_solvencias_pagadas' },
          { text: 'MONTO SOLV. PAGADAS', value: 'monto_solvencias_pagadas' },
          { text: 'CANT. SOLV. PENDIENTES.', value: 'cant_solvencias_pendientes' },
          { text: 'MONTO SOLV. PENDIENTES', value: 'monto_solvencias_pendientes' },
          { text: 'MONTO CONCILIADO', value: 'monto_total_conciliado' }

        ],

      invoices: [
          {
            meses: 'ENERO',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_hojas_seg_pagadas: 0,
            monto_hojas_seg_pagadas: 0,
            cant_rap_pagados: 0,
            monto_rap_pagados: 0,
            monto_total_conciliado: 0
          },
          {
            meses: 'FEBRERO',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_hojas_seg_pagadas: 0,
            monto_hojas_seg_pagadas: 0,
            cant_rap_pagados: 0,
            monto_rap_pagados: 0,
            monto_total_conciliado: 0
          },
          {
            meses: 'MARZO',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_hojas_seg_pagadas: 0,
            monto_hojas_seg_pagadas: 0,
            cant_rap_pagados: 0,
            monto_rap_pagados: 0,
            monto_total_conciliado: 0
          },
          {
            meses: 'ABRIL',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_hojas_seg_pagadas: 0,
            monto_hojas_seg_pagadas: 0,
            cant_rap_pagados: 0,
            monto_rap_pagados: 0,
            monto_total_conciliado: 0
          },
          {
            meses: 'MAYO',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_hojas_seg_pagadas: 0,
            monto_hojas_seg_pagadas: 0,
            cant_rap_pagados: 0,
            monto_rap_pagados: 0,
            monto_total_conciliado: 0
          },
          {
            meses: 'JUNIO',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_hojas_seg_pagadas: 0,
            monto_hojas_seg_pagadas: 0,
            cant_rap_pagados: 0,
            monto_rap_pagados: 0,
            monto_total_conciliado: 0
          },
          {
            meses: 'JULIO',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_hojas_seg_pagadas: 0,
            monto_hojas_seg_pagadas: 0,
            cant_rap_pagados: 0,
            monto_rap_pagados: 0,
            monto_total_conciliado: 0
          },
          {
            meses: 'AGOSTO',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_hojas_seg_pagadas: 0,
            monto_hojas_seg_pagadas: 0,
            cant_rap_pagados: 0,
            monto_rap_pagados: 0,
            monto_total_conciliado: 0
          },
          {
            meses: 'SEPTIEMBRE',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_hojas_seg_pagadas: 0,
            monto_hojas_seg_pagadas: 0,
            cant_rap_pagados: 0,
            monto_rap_pagados: 0,
            monto_total_conciliado: 0
          },
          {
            meses: 'OCTUBRE',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_hojas_seg_pagadas: 0,
            monto_hojas_seg_pagadas: 0,
            cant_rap_pagados: 0,
            monto_rap_pagados: 0,
            monto_total_conciliado: 0
          },
          {
            meses: 'NOVIEMBRE',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_hojas_seg_pagadas: 0,
            monto_hojas_seg_pagadas: 0,
            cant_rap_pagados: 0,
            monto_rap_pagados: 0,
            monto_total_conciliado: 0
          },
          {
            meses: 'DICIEMBRE',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_hojas_seg_pagadas: 0,
            monto_hojas_seg_pagadas: 0,
            cant_rap_pagados: 0,
            monto_rap_pagados: 0,
            monto_total_conciliado: 0
          }
        ],
      sostenimiento: [
          {
            meses: 'ENERO',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_solvencias_pagadas: 0,
            monto_solvencias_pagadas: 0,
            cant_solvencias_pendientes: 0,
            monto_solvencias_pendientes: 0,
            monto_total_conciliado: 0
          },
          {
            meses: 'FEBRERO',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_solvencias_pagadas: 0,
            monto_solvencias_pagadas: 0,
            cant_solvencias_pendientes: 0,
            monto_solvencias_pendientes: 0,
            monto_total_conciliado: 0
          },
          {
            meses: 'MARZO',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_solvencias_pagadas: 0,
            monto_solvencias_pagadas: 0,
            cant_solvencias_pendientes: 0,
            monto_solvencias_pendientes: 0,
            monto_total_conciliado: 0
          },
          {
            meses: 'ABRIL',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_solvencias_pagadas: 0,
            monto_solvencias_pagadas: 0,
            cant_solvencias_pendientes: 0,
            monto_solvencias_pendientes: 0,
            monto_total_conciliado: 0
          },
          {
            meses: 'MAYO',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_solvencias_pagadas: 0,
            monto_solvencias_pagadas: 0,
            cant_solvencias_pendientes: 0,
            monto_solvencias_pendientes: 0,
            monto_total_conciliado: 0
          },
          {
            meses: 'JUNIO',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_solvencias_pagadas: 0,
            monto_solvencias_pagadas: 0,
            cant_solvencias_pendientes: 0,
            monto_solvencias_pendientes: 0,
            monto_total_conciliado: 0
          },
          {
            meses: 'JULIO',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_solvencias_pagadas: 0,
            monto_solvencias_pagadas: 0,
            cant_solvencias_pendientes: 0,
            monto_solvencias_pendientes: 0,
            monto_total_conciliado: 0
          },
          {
            meses: 'AGOSTO',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_solvencias_pagadas: 0,
            monto_solvencias_pagadas: 0,
            cant_solvencias_pendientes: 0,
            monto_solvencias_pendientes: 0,
            monto_total_conciliado: 0
          },
          {
            meses: 'SEPTIEMBRE',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_solvencias_pagadas: 0,
            monto_solvencias_pagadas: 0,
            cant_solvencias_pendientes: 0,
            monto_solvencias_pendientes: 0,
            monto_total_conciliado: 0
          },
          {
            meses: 'OCTUBRE',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_solvencias_pagadas: 0,
            monto_solvencias_pagadas: 0,
            cant_solvencias_pendientes: 0,
            monto_solvencias_pendientes: 0,
            monto_total_conciliado: 0
          },
          {
            meses: 'NOVIEMBRE',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_solvencias_pagadas: 0,
            monto_solvencias_pagadas: 0,
            cant_solvencias_pendientes: 0,
            monto_solvencias_pendientes: 0,
            monto_total_conciliado: 0
          },
          {
            meses: 'DICIEMBRE',
            cantidad_facturas: 0,
            monto_facturado: 0,
            cant_solvencias_pagadas: 0,
            monto_solvencias_pagadas: 0,
            cant_solvencias_pendientes: 0,
            monto_solvencias_pendientes: 0,
            monto_total_conciliado: 0
          }
        ]
    }
  },
  created () {
    this.yearMonthString = moment().format('MMMM YYYY');
    this.yearString = moment().format('YYYY');
    this.yearMonthLastString = moment().subtract(1, 'months').add(1, 'days').format('MMMM YYYY');
  },

  computed: {
    ...mapGetters({
      user: 'authUser',
      list: 'getTematicList'
    })
  },

  mounted() {
    this.$store.dispatch('fetchUser')
    this.$store.dispatch('fetchTematic')
    this.getAdminMetricas()
  },

  methods: {

    filterRole(role) {
      let exists = false
      exists = this.user.roles.filter(rol => {
        for (let index = 0; index < role.length; index++) {
          if(rol.slug === role[index]){
            return rol
          }
        }
      }).length != 0 ? true : false

      return exists
    },

    formatNumberBs() {
      const formatter = new Intl.NumberFormat('es-VE', {
      style: 'currency',
      currency: 'BsS. ',
      minimumFractionDigits: 0
    })
    },



    recorridoActuaciones(metricas){
      let porrevisar = 0
      let pendientes = 0
      this.misactuaciones = metricas.length
      metricas.forEach(rape => {
        let count = 0
        let valido = 0
        rape.document_requiremets.forEach(element => {
            if(element.supervisor_check == null){
              count++
            }
            if(element.supervisor_check == true){
              valido++
            }
        });
        if(count != 0){
          porrevisar++
        }
        if(valido == rape.document_requiremets.length && rape.service_payments.length == 0){
          pendientes++
        }

        if(rape.service_payments.length != 0){
          if(rape.service_payments[0].invoice.agreement == false){
            pendientes++
          }
        }
      });

      this.porrevisar = porrevisar
      this.pendientes = pendientes
    },

    async getAdminMetricas(){
      await axios.get(`/api/metricas`).then(resp => {
        this.agremiados = resp.data.agremiados
        this.credito = resp.data.credito
        this.insolventes = resp.data.insolventes
        this.nuevoIngreso = resp.data.nuevos
        this.ingresoMesActual = resp.data.nuevo
        this.items = resp.data.items
        this.sostenimiento = resp.data.sostenimiento
        this.invoices = resp.data.invoices
        this.itemsLast = resp.data.itemsLast
        this.ingresoMesPasado = resp.data.nuevoMesPasado
        this.ruapsHoy = resp.data.ruapsHoy
        this.activos_portal = resp.data.activos_portal
        this.magazzineDownload = resp.data.magazzineDownload
        if(resp.data.metricas_agremiado.length != 0){
          this.recorridoActuaciones(resp.data.metricas_agremiado)
        }
      }).catch(error => {
        console.log(error.response)
      })
    }

  }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/metrics.vue